import { INVOICES } from 'pages/MyAccount/services/actions/invoicesActions';
import type { Action } from 'pages/MyAccount/services/actions/Action.type';

export type InvoicesState = {|
  +order: Object,
|};

export const invoicesInitialState = {
  order: null,
};

export const invoicesReducer = (
  state: InvoicesState = invoicesInitialState,
  action: Action
): InvoicesState => {
  switch (action.type) {
    case INVOICES.RECEIVE_ORDER_CONFIRMATION: {
      return {
        ...state,
        order: action.order,
      };
    }

    default: {
      return state;
    }
  }
};

export default invoicesReducer;
